import styled from 'styled-components';
import { P } from '@components/typography/new';
import { colors } from '@nandosaus/constants';
import { Box } from '@components/grid';
import { navigation } from '@constants/navigation';
import { Alert } from '@components/alert';
import { space } from 'styled-system';

export const ErrorMessage = styled(P)`
  color: ${colors.red600};
`;

export const ErrorAlert = () => (
  <Box pb="0.75rem">
    <Alert heading="A critical error has occurred" type="error" href={navigation.HOME}>
      Our team has been notified and is working hard to fix this problem.
    </Alert>
  </Box>
);

export const InactiveError = styled(P)`
  color: ${colors.grey400};
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 20px;
  padding: 32px 0 32px 0;
  ${space}
`;
